import {
    EXTRALIST_SUCCESS,
    SETEXTRA
} from "../actions/extraList";
import Vue from "vue";

const state = {
    extraList: []
};

const getters = {
    getExtraList: state => state.extraList,
};

const mutations = {
    [EXTRALIST_SUCCESS]: (state, resp) => {
        var list = resp.data.map(it => {
            var item = { ...it };
            item.Quantity = 0;
            return item;
        });
        Vue.set(state, "extraList", list);
    },
    [SETEXTRA]: (state, data) => {
        var index = state.extraList.findIndex(f => f.ObjectId == data.objectId);
        state.extraList[index].Quantity = parseInt(data.value);
    }
};

export default {
    state,
    getters,
    mutations
};